import { Maximize2 } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Offerings() {
  return (
    <section className="section-pad" data-testid="offerings-section" aria-label="Categorie e servizi di Farma Store">
      <div className="container-x text-center">
        <SectionHeading
          align="center"
          label="Categorie & Servizi"
          title="Tutto ciò che trovi da Farma Store"
          sub="Salute, dermocosmesi, integrazione e servizi professionali in un unico punto di riferimento."
        />
        <Reveal delay={0.15} className="mt-12 sm:mt-16">
          <a
            href="/images/categorie-servizi.png"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="offerings-image-link"
            aria-label="Apri la grafica delle categorie e dei servizi a schermo intero"
            className="group mx-auto block max-w-[960px]"
          >
            <div className="rounded-[2rem] border border-black/[0.06] bg-white p-4 transition-shadow duration-500 group-hover:shadow-[0_30px_60px_-30px_rgba(28,29,31,0.25)] sm:p-8 lg:p-10">
              <img
                src="/images/categorie-servizi.png"
                alt="Categorie e servizi di Farma Store: farmaci senza ricetta SOP e OTC, dispositivi medici e automedicazione, integratori, dermocosmesi, mamma e infanzia, igiene e cura della persona, consulenze professionali"
                loading="lazy"
                className="h-auto w-full"
                width="1456"
                height="1040"
              />
            </div>
          </a>
          <p className="mt-5 inline-flex items-center gap-1.5 text-xs font-medium text-[#888c95]">
            <Maximize2 className="h-3.5 w-3.5" />
            Tocca l&rsquo;immagine per ingrandirla
          </p>
        </Reveal>
      </div>
    </section>
  );
}
